export { AtnAddRecordDialogComponent as Component } from './component'
